import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

function Modal({
  large,
  onDismiss,
  children
}) {
  return (
    <div className={classnames(
      'Modal',
      {
        'Modal--large': large
      }
    )}>
      <button
        className='Modal-close'
        onClick={onDismiss}
      >×</button>

      {children}
    </div>
  );
}

Modal.propTypes = {
  large: PropTypes.bool,
  onDismiss: PropTypes.func
};

Modal.defaultProps = {
  large: false,
  onDismiss: () => false
};

export default Modal;


// WEBPACK FOOTER //
// ./src/components/Modal.js